module.exports = __webpack_public_path__ + "static/img/p6_16.356e2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filmSelfPrinter/p6_16.png
// module id = gJ5z
// module chunks = 0